import { z } from 'zod'

const counts = z.record(z.string(), z.int().nonnegative())

/**
 * What «Налаштування» shows beside each list item: how much of the CRM uses it, so a person
 * sees why it cannot be hidden, archived or deleted before trying. Keys are the item's key, code
 * or id, as each list uses it.
 */
export const settingsUsageSchema = z.object({
  /** Deals in each CRM status, by status key. */
  dealStages: counts,
  /** Deals still open (not in an unsuccessful status) in each currency, by code. */
  currencies: counts,
  /** By seller entity id. */
  sellerEntities: z.record(
    z.string(),
    z.object({
      deals: z.int().nonnegative(),
      invoices: z.int().nonnegative(),
      clients: z.int().nonnegative(),
    }),
  ),
  /**
   * Products whose latest released technology card goes through each stage, by template id.
   * `productId` is the engineering product; `label` its first catalog code, else its name.
   */
  stageTemplates: z.record(
    z.string(),
    z.array(z.object({ productId: z.string(), label: z.string() })),
  ),
  /** Materials lying in each place, by location id. */
  locations: counts,
  /** Active materials in each category, by category code. */
  categories: counts,
  /** Active materials counted in each unit (base or purchase unit), by unit code. */
  units: counts,
})
export type SettingsUsage = z.infer<typeof settingsUsageSchema>
